@if (step === portSteps.select_provider) {
  <app-phonenumber-port-provider
    (onBack)="back()"
    countryCode="AT"
  (onNext)="onProviderSelected($event)"></app-phonenumber-port-provider>
}


@if (step === portSteps.select_phone_numbers) {
  <app-phonenumber-port-one-number
    [countryCode]="countryCode"
    [trunkPrefix]="trunkPrefix"
    (onBack)="stepBack()"
    (selected)="onSelectNumbersToPortComplete($event)">
  </app-phonenumber-port-one-number>
}
